module.exports = __webpack_public_path__ + "img/hero.189a254c.png";